import React, { useEffect, useState } from "react";
import { getDecryptedUserFromCookie } from "../utils/getCookie";
import { useSidebar } from "../../SidebarContext";
import { toast } from "react-toastify";
import ReactQuill from "react-quill";
import { useRef } from "react";
import DOMPurify from 'dompurify';
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import { decryptToken } from "../utils/getToken";



const Setting = () => {
    const url = process.env.REACT_APP_LINK;
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const [userData, setUserData] = useState(null);
    const [editMode, setEditMode] = useState(false);
    const [editMode1, setEditMode1] = useState(false);
    const [editMeta, setEditMeta] = useState(false);
    const [editMode1cart, setEditMode1cart] = useState(false);
    const [formData, setFormData] = useState({});
    const [help, setHelp] = useState({})
    const [userDatahelp, setUserDatahelp] = useState(null);
    const [useTextLogo, setUseTextLogo] = useState(false);
    const { isSidebarOpen } = useSidebar();
    const [deliveryPayData, setDeliveryPayData] = useState({});
    const [editDelivery, setEditDelivery] = useState(false);
    const autocompleteRef = useRef(null);
    const [deliveryRanges, setDeliveryRanges] = useState([]);
    const [newRange, setNewRange] = useState([{ price: "", min_km: "", max_km: "" }]);
    const [editId, setEditId] = useState(null);
    const [submittedRanges, setSubmittedRanges] = useState([]);
    const [cartButtons, setCartButtons] = useState([]);
    const [editButtonData, setEditButtonData] = useState(null); // for modal editing
    const [payButtons, setPayButtons] = useState([]);
    const [editpayButtonData, setpayEditButtonData] = useState(null); // for modal editing
    const [gstData, setGstData] = useState({ gstPercent: "" });
    const [editGst, setEditGst] = useState(false);
    const [guestData, setGuestData] = useState({ totalminimum: "" });
    const [editGuest, setEditGuest] = useState(false);
    const [meta, setMeta] = useState({});           // meta info object
    const [iconFile, setIconFile] = useState(null); // uploaded icon file
    const [metaData, setMetaData] = useState({
        title: "",
        description: "",
        keywords: "",
        author: "",
        scripts: "",
        icon: ""
    })
    // const [editMeta, setEditMeta] = useState(false);
    const [userMeta, setUserMeta] = useState({});
    const { isLoaded } = useJsApiLoader({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
        libraries: ["places"],
    });



    const token = decryptToken("accessToken") || ""
  

    const fetchSingleuser = async () => {
        try {
            const response = await fetch(`${url}/register/single/${isLoggedIn.main_id}`, {
                method: "GET",
                
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                
            });
        const res = await response.json();
        setUserData(res.users);
        console.log(res.users)
        setFormData(res.users);
    } catch (error) {
        console.log(error);
    }
};

const fetchHelpuser = async () => {
    try {
        const response = await fetch(`${url}/help/single/${isLoggedIn.main_id}`);
        const res = await response.json();

        console.log(res.help)
        setUserDatahelp(res.help);
        setHelp(res.help);
    } catch (error) {
        console.log(error);
    }
};

const addDeliveryRange = () => {
    setNewRange([...newRange, { price: "", min_km: "", max_km: "" }]);
};

const updateDeliveryRange = (index, field, value) => {
    const updatedRanges = [...newRange];
    updatedRanges[index][field] = value;
    setNewRange(updatedRanges);
};

const saveEdit = async (id) => {
    const updated = deliveryRanges.find(r => r.id === id);
    const res = await fetch(`${url}/freedelivery/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updated),
    });
    const result = await res.json();
    if (!res.ok) return alert("Update failed");

    setEditId(null);
};


const handleMetaSubmit = async (meta) => {
    const formData = new FormData();

    Object.entries(meta).forEach(([key, val]) => {
        if (val && key !== "iconFile") formData.append(key, val);
    });

    if (meta.iconFile) {
        formData.append("icon", meta.iconFile);
    }

    try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/meta`, {
            method: "POST", // or "PUT"
            body: formData,
        });
        const result = await res.json();
        if (res.ok) {
            alert("Meta details updated");
        } else {
            alert(result.message || "Failed to update");
        }
    } catch (err) {
        console.error(err);
        alert("Server error");
    }
};


const submitDeliveryRanges = async () => {
    try {
        for (let i = 0; i < newRange.length; i++) {
            const { price, min_km, max_km } = newRange[i];

            if (!price || !min_km || !max_km) {
                alert(`All fields must be filled at row ${i + 1}`);
                return;
            }

            const res = await fetch(`${url}/freedelivery`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    min_kilometer: min_km,
                    max_kilometer: max_km,
                    freedelivery_price: price,
                    status: 1, // static or dynamic
                    user_id: userData.main_id,
                    user_name: userData.full_name,
                }),
            });

            const result = await res.json();

            if (!res.ok) {
                throw new Error(result.message || "Submission failed");
            }
        }

        setSubmittedRanges([...newRange]);
        setNewRange([{ price: "", min_km: "", max_km: "" }]);
        alert("Free delivery ranges submitted successfully!");
    } catch (error) {
        console.error("Error submitting:", error);
        alert("Error: " + error.message);
    }
};


const fetchDeliveryPayData = async () => {
    try {
        const response = await fetch(`${url}/deliverypaybefore/single/${isLoggedIn.main_id}`);
        const res = await response.json();
        setDeliveryPayData(res.help || {}); // similar to help structure
    } catch (error) {
        console.error("Error fetching delivery data:", error);
    }
};

const fetchGSTData = async () => {
    try {
        const res = await fetch(`${url}/gst/${isLoggedIn.main_id}`);
        const data = await res.json();
        if (res.ok) {
            setGstData(data);
        }
    } catch (error) {
        console.error("Failed to fetch GST data", error);
    }
};


const fetchMetaData = () => {

}


useEffect(() => {
    fetchSingleuser();
    fetchHelpuser();
    fetchDeliveryPayData();
    fetchGSTData();
}, []);

const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
};

const handleGstChange = (e) => {
    setGstData({ ...gstData, gstPercent: e.target.value });
};


const handleLogoChange = (e) => {
    const file = e.target.files[0];
    setFormData({ ...formData, profilePic: file, orignal_logoname: null });
};

const handlePlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (place && place.formatted_address) {
        setFormData((prev) => ({
            ...prev,
            google_address: place.formatted_address,
        }));
    }
};

const handleTextLogoChange = (e) => {
    setFormData({ ...formData, orignal_logoname: e.target.value, profilePic: null });
};

const handleSubmit = async () => {
    const form = new FormData();
    for (let key in formData) {
        if (formData[key] !== null) form.append(key, formData[key]);
    }

    try {
        const res = await fetch(`${url}/register/change/${isLoggedIn.main_id}`, {
            method: "PUT",
            mode: "cors",
            credentials: "include",
            headers: {
                Authorization: `Bearer ${token}`,
            },
            body: form,

        });
        const data = await res.json();
        console.log(data)
        // toast.success("Profile updated successfully");
        setEditMode(false);
        fetchSingleuser();
    } catch (err) {
        console.error("Update error:", err);
    }
};

const handleHelpSubmit = async () => {
    try {
        const method = userDatahelp ? "PUT" : "POST";
        const endpoint = userDatahelp
            ? `${url}/help/${isLoggedIn.main_id}`
            : `${url}/help`;

        const response = await fetch(endpoint, {
            method,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                ...help,
                user_id: isLoggedIn.main_id,
                user_name: isLoggedIn.full_name
            }),
        });

        const result = await response.json();

        if (response.ok) {
            toast.success(`Help info ${method === "POST" ? "created" : "updated"} successfully`);
            setUserDatahelp(help);
            setEditMode1(false);
        } else {
            toast.error(result.message || "Failed to save help info");
        }
    } catch (error) {
        console.error("Help save error:", error);
        toast.error("Error saving help info");
    }
};

const handleDeliveryPaySubmit = async () => {
    try {
        const method = deliveryPayData?.id ? "PUT" : "POST";
        const endpoint = deliveryPayData?.id
            ? `${url}/deliverypaybefore/${isLoggedIn.main_id}`
            : `${url}/deliverypaybefore`;

        const response = await fetch(endpoint, {
            method,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                ...deliveryPayData,
                user_id: isLoggedIn.main_id,
                user_name: isLoggedIn.full_name,
            }),
        });

        const result = await response.json();
        if (response.ok) {
            toast.success(`Delivery policy ${method === "POST" ? "created" : "updated"} successfully`);
            setEditDelivery(false);
            fetchDeliveryPayData();
        } else {
            toast.error(result.message || "Failed to save delivery policy");
        }
    } catch (error) {
        toast.error("Error saving delivery policy");
        console.error(error);
    }
};

useEffect(() => {
    if (editMode && window.google && autocompleteRef.current) {
        const autocomplete = new window.google.maps.places.Autocomplete(autocompleteRef.current, {
            types: ["geocode"],
            componentRestrictions: { country: "in" }, // Optional: restrict to India
        });

        autocomplete.addListener("place_changed", () => {
            const place = autocomplete.getPlace();
            if (place.formatted_address) {
                setFormData((prev) => ({
                    ...prev,
                    google_address: place.formatted_address,
                }));
            }
        });
    }
}, [editMode]);

const deleteRange = async (id) => {
    if (!window.confirm("Delete this range?")) return;
    const res = await fetch(`${url}/freedelivery/${id}`, { method: "DELETE" });
    const result = await res.json();
    if (!res.ok) return alert("Delete failed");

    setDeliveryRanges(prev => prev.filter(r => r.id !== id));
};

console.log(userData)
useEffect(() => {
    fetch(`${url}/freedelivery/${isLoggedIn.main_id}`)
        .then(res => res.json())
        .then(data => {
            if (!data.isError) {
                setDeliveryRanges(data.data);
            }
        });
}, []);

const removeDeliveryRange = (index) => {
    setNewRange((prev) => prev.filter((_, i) => i !== index));
};

const cartOption = async () => {
    try {
        const response = await fetch(`${url}/button/${isLoggedIn.main_id}`)
        const res = await response.json();
        console.log(res.data);
        setCartButtons(res.data);
    } catch (error) {
        console.log(error)
    }
}

const paymentOption = async () => {
    try {
        const response = await fetch(`${url}/paybutton/${isLoggedIn.main_id}`)
        const res = await response.json();
        console.log(res.data);
        setPayButtons(res.data);
    } catch (error) {
        console.log(error)
    }
}


const handleSaveEdit = async () => {
    const { id, button_id, button, default: isDefault } = editButtonData;

    try {
        // Base update
        const updates = [{ id, button, default: isDefault }];

        // Apply rule:
        if (isDefault) {
            if (button_id === "getquote") {
                // If "Get Quote" is set to default, unset "addtocart" and "buynow"
                cartButtons.forEach(b => {
                    if ((b.button_id === "addtocart" || b.button_id === "buynow") && b.default) {
                        updates.push({ id: b.id, default: false });
                    }
                });
            } else {
                // If "addtocart" or "buynow" is set to default AND getquote is true, unset getquote
                cartButtons.forEach(b => {
                    if (b.button_id === "getquote" && b.default) {
                        updates.push({ id: b.id, default: false });
                    }
                });
            }
        }

        // Send batch update
        const response = await fetch(`${url}/button/api/update-cart-buttons`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
        });

        const result = await response.json();

        if (!result.isError) {
            // Update frontend
            const updated = cartButtons.map(btn => {
                const found = updates.find(u => u.id === btn.id);
                return found ? { ...btn, ...found } : btn;
            });
            setCartButtons(updated);
            setEditButtonData(null);
        } else {
            alert("Failed to update");
        }

    } catch (err) {
        console.error(err);
        alert("Error occurred");
    }
};


const handleSavePaymentEdit = async () => {
    const { id, button_id, button, default: isDefault } = editpayButtonData;

    try {
        // Base update
        const updates = [{ id, button, default: isDefault }];

        // Apply rule:
        if (isDefault) {
            if (button_id === "paymanual") {
                // If "Get Quote" is set to default, unset "addtocart" and "buynow"
                payButtons.forEach(b => {
                    if ((b.button_id === "paynow" || b.button_id === "payondelivery") && b.default) {
                        updates.push({ id: b.id, default: false });
                    }
                });
            } else {
                // If "addtocart" or "buynow" is set to default AND getquote is true, unset getquote
                payButtons.forEach(b => {
                    if (b.button_id === "paymanual" && b.default) {
                        updates.push({ id: b.id, default: false });
                    }
                });
            }
        }

        // Send batch update
        const response = await fetch(`${url}/paybutton/api/update-cart-buttons`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ updates }),
        });

        const result = await response.json();

        if (!result.isError) {
            // Update frontend
            const updated = payButtons.map(btn => {
                const found = updates.find(u => u.id === btn.id);
                return found ? { ...btn, ...found } : btn;
            });
            setPayButtons(updated);
            setpayEditButtonData(null);
        } else {
            alert("Failed to update");
        }

    } catch (err) {
        console.error(err);
        alert("Error occurred");
    }
};

const handleGstSubmit = async () => {
    try {
        const res = await fetch(`${url}/gst`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                user_id: isLoggedIn.main_id,
                user_name: isLoggedIn.full_name,
                gstPercent: gstData.gstPercent,
            }),
        });
        const result = await res.json();
        if (res.ok) {
            toast.success("GST saved successfully");
            fetchGSTData();
            setEditGst(false);
        } else {
            toast.error(result.message || "Failed to save GST");
        }
    } catch (error) {
        console.error("GST save error:", error);
        toast.error("Error saving GST");
    }
};

// console.log(help)

const handleGuestChange = (e) => {
    setGuestData({ ...guestData, totalminimum: e.target.value });
};

const handleGuestSubmit = async () => {
    try {
        const res = await fetch(`${url}/guest-total`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
                user_id: isLoggedIn.main_id,
                user_name: isLoggedIn.full_name,
                totalminimum: guestData.totalminimum,
            }),
        });
        const result = await res.json();
        if (res.ok) {
            toast.success("Guest saved successfully");
            fetchGUESTData();
            setEditGuest(false);
        } else {
            toast.error(result.message || "Failed to save Guest");
        }
    } catch (error) {
        console.error("Guest save error:", error);
        toast.error("Error saving Guest");
    }
};

const fetchGUESTData = async () => {
    try {
        const res = await fetch(`${url}/guest-total/${isLoggedIn.main_id}`);
        const data = await res.json();
        if (res.ok) {
            setGuestData(data);
        }
    } catch (error) {
        console.error("Failed to fetch GST data", error);
    }
};


useEffect(() => {
    cartOption();
    paymentOption();
    fetchGUESTData();
}, [])

if (!userData) return <p className="hbtecom-loading">Loading...</p>;

return (
    <>
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <div className="hbtecom-container">
                <h2 className="hbtecom-title">Account Settings</h2>
                <div className="hbtecom-profile-box">
                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Full Name:</label>
                        {editMode ? (
                            <input
                                name="full_name"
                                value={formData.full_name || ""}
                                onChange={handleChange}
                                className="hbtecom-input"
                                placeholder="Enter Full Name"
                            />
                        ) : (
                            <span>{userData.full_name}</span>
                        )}
                    </div>

                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Email:</label>
                        <span>{userData.email}</span>
                    </div>

                    <div className="hbtecom-field">
                        <label className="hbtecom-label"> ID:</label>
                        <span>{userData.main_id}</span>
                    </div>

                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Status:</label>
                        <span>{userData.status}</span>
                    </div>

                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Type:</label>
                        <span>{userData.type}</span>
                    </div>
                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Mobile:</label>

                        {editMode ? (
                            <input
                                name="mobile"
                                value={formData.mobile || ""}
                                onChange={handleChange}
                                className="hbtecom-input"
                                placeholder="Enter Mobile"
                            />
                        ) : (
                            <span>{userData.mobile || "N/A"}</span>
                        )}
                    </div>
                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Invoice Address:</label>

                        {editMode ? (
                            <input
                                // ref={autocompleteRef}
                                name="office_address"
                                defaultValue={formData.office_address || ""}
                                className="hbtecom-input"
                                onChange={handleChange}
                                placeholder="Enter your operational address"
                            />

                        ) : (
                            <span>{userData.office_address || "N/A"}</span>
                        )}
                    </div>

                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Google Maps Store Address:</label>

                        {console.log(formData)}
                        {editMode ? (
                            isLoaded && (
                                <Autocomplete
                                    onLoad={(autocomplete) => (autocompleteRef.current = autocomplete)}
                                    onPlaceChanged={handlePlaceChanged}
                                    className="hbtecom-field"
                                >
                                    <input
                                        type="text"
                                        name="google_address"
                                        value={formData.google_address}
                                        onChange={handleChange}
                                        className="hbtecom-input"
                                        placeholder="Enter your Google address"
                                    />
                                </Autocomplete>
                            )

                        ) : (
                            <span>{userData.google_address || "N/A"}</span>
                        )}
                    </div>

                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Customer Note:</label>

                        {editMode ? (
                            <ReactQuill
                                theme="snow"
                                name="custom_note"
                                value={formData.custom_note || ""}
                                onChange={(value) =>
                                    setFormData((prev) => ({ ...prev, custom_note: value }))
                                }
                                className="hbtecom-input"
                                placeholder="Add Customer Note"
                            />
                        ) : (
                            <div
                                className="hbtecom-note"
                                dangerouslySetInnerHTML={{
                                    __html: DOMPurify.sanitize(userData?.custom_note || "N/A"),
                                }}
                            />
                        )}
                    </div>
                    <div className="hbtecom-field">
                        <label className="hbtecom-label">Tag Line:</label>

                        {editMode ? (
                            <input
                                name="tag_line"
                                value={formData.tag_line || ""}
                                onChange={handleChange}
                                className="hbtecom-input"
                                placeholder="Add Tagline"
                            />
                        ) : (
                            <span>{userData.tag_line || "N/A"}</span>
                        )}
                    </div>
                    {editMode && (
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Logo Type:</label>

                            <select
                                className="hbtecom-input"
                                value={useTextLogo ? "text" : "image"}
                                onChange={(e) => setUseTextLogo(e.target.value === "text")}
                            >
                                <option value="image">Upload Image</option>
                                <option value="text">Use Text Logo</option>
                            </select>

                        </div>
                    )}


                    {useTextLogo && (
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Text Logo Name:</label>
                            {
                                editMode ? (
                                    <input
                                        type="text"
                                        name="orignal_logoname"
                                        value={formData.orignal_logoname || ""}
                                        onChange={(e) => {
                                            setFormData({ ...formData, orignal_logoname: e.target.value, profilePic: null });
                                        }}
                                        className="hbtecom-input"
                                        placeholder="Add Logoname"
                                    />
                                ) : (
                                    <span>{userData.orignal_logoname || "N/A"}</span>
                                )}


                        </div>
                    )}


                    {editMode ? (
                        !useTextLogo && (
                            <div className="hbtecom-field">
                                <label className="hbtecom-label">Upload Logo:</label>
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) => {
                                        setFormData({ ...formData, profilePic: e.target.files[0], orignal_logoname: null });
                                    }}
                                    className="hbtecom-input"
                                />
                            </div>
                        )
                    ) : (
                        <div className="hbtecom-field">
                            <label className="hbtecom-label">Logo:</label>
                            {userData.profilePic ? (
                                <img
                                    src={`${url}/uploads/profile/${userData.profilePic}`}
                                    alt="Profile"
                                    className="hbtecom-profile-pic"
                                />
                            ) : userData.orignal_logoname ? (
                                <span className="hbtecom-text-logo">{userData.orignal_logoname}</span>
                            ) : (
                                <span>No logo set</span>
                            )}
                        </div>
                    )}


                    {/* <div className="hbtecom-field">
                            <label className="hbtecom-label">Upload Logo:</label>
                            {editMode ? (
                                <input
                                    type="file"
                                    accept="image/*"
                                    onChange={handleLogoChange}
                                    disabled={!!formData.orignal_logoname}
                                    className="hbtecom-input"
                                />
                            ) : (
                                <>
                                    {
                                        userData.profilePic ? (
                                            <img
                                                src={`${url}/uploads/profile/${userData.profilePic}`}
                                                alt="Profile"
                                                className="hbtecom-profile-pic"
                                            />
                                        ) : (
                                            <span>No image uploaded</span>
                                        )
                                    }
                                </>

                            )}
                        </div> */}

                    <div className="hbtecom-buttons">
                        {editMode ? (
                            <>
                                <button className="hbtecom-btn hbtecom-save" onClick={handleSubmit}>Save</button>
                                <button className="hbtecom-btn hbtecom-cancel" onClick={() => setEditMode(false)}>Cancel</button>
                            </>
                        ) : (
                            <button className="hbtecom-btn hbtecom-edit" onClick={() => setEditMode(true)}>Edit</button>
                        )}
                    </div>

                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">Help & Support</h3>
                            {!editMode1 && (
                                <button
                                    className="hbtecom-btn hbtecom-help-edit"
                                    onClick={() => setEditMode1(true)}
                                >
                                    Edit
                                </button>
                            )}
                        </div>

                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Support Mobile Number:</label>
                            {editMode1 ? (
                                <input
                                    type="text"
                                    name="mobile"
                                    value={help?.mobile || ""}
                                    onChange={(e) =>
                                        setHelp((prev) => ({ ...prev, mobile: e.target.value }))
                                    }
                                    className="hbtecom-help-input"
                                    placeholder="Enter support mobile number"
                                />
                            ) : (
                                <span className="hbtecom-help-text">
                                    {userDatahelp?.mobile || "N/A"}
                                </span>
                            )}
                        </div>

                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Support WhatsApp Number:</label>
                            {editMode1 ? (
                                <input
                                    type="text"
                                    name="whatsapp_number"
                                    value={help?.whatsapp_number || ""}
                                    onChange={(e) =>
                                        setHelp((prev) => ({ ...prev, whatsapp_number: e.target.value }))
                                    }
                                    className="hbtecom-help-input"
                                    placeholder="Enter WhatsApp number"
                                />
                            ) : (
                                <span className="hbtecom-help-text">
                                    {userDatahelp?.whatsapp_number || "N/A"}
                                </span>
                            )}
                        </div>

                        {editMode1 && (
                            <div className="hbtecom-buttons">
                                <button className="hbtecom-btn hbtecom-save" onClick={handleHelpSubmit}>
                                    Save Help Info
                                </button>
                                <button
                                    className="hbtecom-btn hbtecom-cancel"
                                    onClick={() => {
                                        setEditMode1(false);
                                        setHelp(userDatahelp);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">Delivery on Cash Before Pay</h3>
                            {!editDelivery && (
                                <button
                                    className="hbtecom-btn hbtecom-help-edit"
                                    onClick={() => setEditDelivery(true)}
                                >
                                    Edit
                                </button>
                            )}
                        </div>

                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Delivery Percentage %:</label>
                            {editDelivery ? (
                                <input
                                    type="number"
                                    name="delivery_percentage"
                                    value={deliveryPayData?.delivery_percentage || ""}
                                    onChange={(e) =>
                                        setDeliveryPayData((prev) => ({
                                            ...prev,
                                            delivery_percentage: e.target.value,
                                        }))
                                    }
                                    className="hbtecom-help-input"
                                    placeholder="Enter delivery percentage"
                                />
                            ) : (
                                <span className="hbtecom-help-text">
                                    {deliveryPayData?.delivery_percentage
                                        ? `${deliveryPayData.delivery_percentage}%`
                                        : "N/A"}
                                </span>
                            )}
                        </div>



                        {editDelivery && (
                            <div className="hbtecom-buttons">
                                <button className="hbtecom-btn hbtecom-save" onClick={handleDeliveryPaySubmit}>
                                    Save Delivery Info
                                </button>
                                <button
                                    className="hbtecom-btn hbtecom-cancel"
                                    onClick={() => {
                                        setEditDelivery(false);
                                        fetchDeliveryPayData(); // reset
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>


                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">Cart Option</h3>

                        </div>

                        <div className="hbtecom-help-field">
                            {/* <label className="hbtecom-help-label">Delivery Percentage %:</label> */}
                            {editButtonData && (
                                <div className="hbtecom-modal">
                                    <div className="hbtecom-modal-content">
                                        <h3>Edit Button</h3>
                                        <label>Button Name</label>
                                        <input
                                            type="text"
                                            value={editButtonData.button}
                                            onChange={(e) =>
                                                setEditButtonData({ ...editButtonData, button: e.target.value })
                                            }
                                            className="hbtecom-help-input"
                                        />

                                        <label >
                                            <div className="modalbht-displayflxdefault">
                                                <input
                                                    type="checkbox"
                                                    checked={editButtonData.default}
                                                    onChange={(e) =>
                                                        setEditButtonData({ ...editButtonData, default: e.target.checked })
                                                    }
                                                />
                                                <p>Set as Default</p>
                                            </div>
                                        </label>

                                        <div className="hbtecom-buttons">
                                            <button className="hbtecom-btn hbtecom-save" onClick={handleSaveEdit}>
                                                Save
                                            </button>
                                            <button className="hbtecom-btn hbtecom-cancel" onClick={() => setEditButtonData(null)}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}




                        </div>



                        <table className="customer-table">
                            <thead>
                                <tr>
                                    {/* <th>Button ID</th> */}
                                    <th>Button Name</th>
                                    <th>Default</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {cartButtons.map((btn) => (
                                    <tr key={btn.id}>
                                        {/* <td>{btn.button_id}</td> */}
                                        <td>{btn.button}</td>
                                        <td>{btn.default ? "Yes" : "No"}</td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => setEditButtonData({ ...btn })}
                                            >
                                                <i className="fa-solid fa-pencil"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">Payment Option</h3>

                        </div>

                        <div className="hbtecom-help-field">
                            {/* <label className="hbtecom-help-label">Delivery Percentage %:</label> */}
                            {editpayButtonData && (
                                <div className="hbtecom-modal">
                                    <div className="hbtecom-modal-content">
                                        <h3>Edit Button</h3>
                                        <label>Button Name</label>
                                        <input
                                            type="text"
                                            value={editpayButtonData.button}
                                            onChange={(e) =>
                                                setpayEditButtonData({ ...editpayButtonData, button: e.target.value })
                                            }
                                            className="hbtecom-help-input"
                                        />

                                        <label >
                                            <div className="modalbht-displayflxdefault">
                                                <input
                                                    type="checkbox"
                                                    checked={editpayButtonData.default}
                                                    onChange={(e) =>
                                                        setpayEditButtonData({ ...editpayButtonData, default: e.target.checked })
                                                    }
                                                />
                                                <p>Set as Default</p>
                                            </div>
                                        </label>

                                        <div className="hbtecom-buttons">
                                            <button className="hbtecom-btn hbtecom-save" onClick={handleSavePaymentEdit}>
                                                Save
                                            </button>
                                            <button className="hbtecom-btn hbtecom-cancel" onClick={() => setpayEditButtonData(null)}>
                                                Cancel
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}




                        </div>



                        <table className="customer-table">
                            <thead>
                                <tr>
                                    {/* <th>Button ID</th> */}
                                    <th>Button Name</th>
                                    <th>Default</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {payButtons.map((btn) => (
                                    <tr key={btn.id}>
                                        {/* <td>{btn.button_id}</td> */}
                                        <td>{btn.button}</td>
                                        <td>{btn.default ? "Yes" : "No"}</td>
                                        <td>
                                            <button
                                                className="edit-button"
                                                onClick={() => setpayEditButtonData({ ...btn })}
                                            >
                                                <i className="fa-solid fa-pencil"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>

                    </div>

                    <div className="hbtecom-help-box">
                        <h3 className="hbtecom-besthelpbox"> <p className="hbtecom-help-title">Free Delivery Settings</p> <p className="hbtecom-spantitle">(learn)</p></h3>

                        {newRange.map((range, index) => (
                            <div key={index} className="hbtecom-delivery-range-row">
                                <input
                                    type="number"
                                    placeholder="Price"
                                    className="hbtecom-help-input small"
                                    value={range.price}
                                    onChange={(e) =>
                                        updateDeliveryRange(index, "price", e.target.value)
                                    }
                                />
                                <input
                                    type="number"
                                    placeholder="Min KM"
                                    className="hbtecom-help-input small"
                                    value={range.min_km}
                                    onChange={(e) =>
                                        updateDeliveryRange(index, "min_km", e.target.value)
                                    }
                                />
                                <input
                                    type="number"
                                    placeholder="Max KM"
                                    className="hbtecom-help-input small"
                                    value={range.max_km}
                                    onChange={(e) =>
                                        updateDeliveryRange(index, "max_km", e.target.value)
                                    }
                                />
                                {index === 0 &&
                                    <button
                                        className="hbtecom-btn hbtecom-add"
                                        onClick={() => addDeliveryRange()}
                                    >
                                        <i class="fa-solid fa-plus"></i>
                                    </button>
                                }

                                {index > 0 && (
                                    <button
                                        className="hbtecom-btn hbtecom-remove"
                                        onClick={() => removeDeliveryRange(index)}
                                    >
                                        <i class="fa-solid fa-xmark"></i>
                                    </button>
                                )}
                            </div>
                        ))}

                        <button
                            className="hbtecom-btn hbtecom-submitdelivery"
                            onClick={submitDeliveryRanges}
                            style={{ marginTop: "10px" }}
                        >
                            Submit Delivery Ranges
                        </button>

                        <table className="customer-table">
                            <thead>
                                <tr>
                                    <th>Minimum KM</th>
                                    <th>Maximum KM</th>
                                    <th>Price ₹</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {deliveryRanges.map((range, index) => (
                                    <tr key={range.id}>
                                        <td>
                                            {editId === range.id ? (
                                                <input value={range.min_kilometer} onChange={e => {
                                                    const updated = [...deliveryRanges];
                                                    updated[index].min_kilometer = e.target.value;
                                                    setDeliveryRanges(updated);
                                                }} />
                                            ) : range.min_kilometer}
                                        </td>
                                        <td>
                                            {editId === range.id ? (
                                                <input value={range.max_kilometer} onChange={e => {
                                                    const updated = [...deliveryRanges];
                                                    updated[index].max_kilometer = e.target.value;
                                                    setDeliveryRanges(updated);
                                                }} />
                                            ) : range.max_kilometer}
                                        </td>
                                        <td>
                                            {editId === range.id ? (
                                                <input value={range.freedelivery_price} onChange={e => {
                                                    const updated = [...deliveryRanges];
                                                    updated[index].freedelivery_price = e.target.value;
                                                    setDeliveryRanges(updated);
                                                }} />
                                            ) : range.freedelivery_price}
                                        </td>
                                        <td>
                                            {editId === range.id ? (
                                                <>
                                                    <button className="edit-button" onClick={() => saveEdit(range.id)}><i class="fa-solid fa-floppy-disk"></i></button>
                                                    <button onClick={() => setEditId(null)}><i class="fa-solid fa-xmark"></i></button>
                                                </>
                                            ) : (
                                                <>
                                                    <button className="edit-button" onClick={() => setEditId(range.id)}> <i className="fa-solid fa-pencil edit-oms"></i></button>
                                                    <button className="delete-button" onClick={() => deleteRange(range.id)}> <i className="fa-solid fa-trash delete-oms"></i></button>
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                                {/* <tr> */}
                                {/* <td><input value={newRange.min_km} onChange={e => setNewRange({ ...newRange, min_km: e.target.value })} /></td>
                                        <td><input value={newRange.max_km} onChange={e => setNewRange({ ...newRange, max_km: e.target.value })} /></td>
                                        <td><input value={newRange.price} onChange={e => setNewRange({ ...newRange, price: e.target.value })} /></td>
                                        <td><button onClick={submitDeliveryRanges}>Add</button></td> */}
                                {/* </tr> */}
                            </tbody>
                        </table>
                    </div>
                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">GST Settings</h3>
                            {!editGst && (
                                <button className="hbtecom-btn hbtecom-help-edit" onClick={() => setEditGst(true)}>
                                    Edit
                                </button>
                            )}
                        </div>

                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">GST Percentage:</label>
                            {editGst ? (
                                <input
                                    type="number"
                                    name="gstPercent"
                                    value={gstData?.gstPercent || ""}
                                    onChange={handleGstChange}
                                    className="hbtecom-help-input"
                                    placeholder="Enter GST %"
                                />
                            ) : (
                                <span className="hbtecom-help-text">
                                    {gstData?.gstPercent ? `${gstData.gstPercent}%` : "N/A"}
                                </span>
                            )}
                        </div>

                        {editGst && (
                            <div className="hbtecom-buttons">
                                <button className="hbtecom-btn hbtecom-save" onClick={handleGstSubmit}>
                                    Save GST Info
                                </button>
                                <button
                                    className="hbtecom-btn hbtecom-cancel"
                                    onClick={() => {
                                        fetchGSTData(); // reset to existing
                                        setEditGst(false);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">Meta Details</h3>
                            {!editMeta && (
                                <button className="hbtecom-btn hbtecom-help-edit" onClick={() => setEditMeta(true)}>
                                    Edit
                                </button>
                            )}
                        </div>

                        {/* Title */}
                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Meta Title:</label>
                            {editMeta ? (
                                <input
                                    type="text"
                                    name="title"
                                    value={meta.title || ""}
                                    onChange={(e) => setMeta((prev) => ({ ...prev, title: e.target.value }))}
                                    className="hbtecom-help-input"
                                    placeholder="Enter meta title"
                                />
                            ) : (
                                <span className="hbtecom-help-text">{meta.title || "N/A"}</span>
                            )}
                        </div>

                        {/* Description */}
                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Meta Description:</label>
                            {editMeta ? (
                                <textarea
                                    name="description"
                                    value={meta.description || ""}
                                    onChange={(e) => setMeta((prev) => ({ ...prev, description: e.target.value }))}
                                    className="hbtecom-help-input"
                                    placeholder="Enter meta description"
                                    rows={3}
                                />
                            ) : (
                                <span className="hbtecom-help-text">{meta.description || "N/A"}</span>
                            )}
                        </div>

                        {/* Keywords */}
                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Meta Keywords:</label>
                            {editMeta ? (
                                <input
                                    type="text"
                                    name="keywords"
                                    value={meta.keywords || ""}
                                    onChange={(e) => setMeta((prev) => ({ ...prev, keywords: e.target.value }))}
                                    className="hbtecom-help-input"
                                    placeholder="Enter meta keywords"
                                />
                            ) : (
                                <span className="hbtecom-help-text">{meta.keywords || "N/A"}</span>
                            )}
                        </div>

                        {/* Author */}
                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Author:</label>
                            {editMeta ? (
                                <input
                                    type="text"
                                    name="author"
                                    value={meta.author || ""}
                                    onChange={(e) => setMeta((prev) => ({ ...prev, author: e.target.value }))}
                                    className="hbtecom-help-input"
                                    placeholder="Enter author"
                                />
                            ) : (
                                <span className="hbtecom-help-text">{meta.author || "N/A"}</span>
                            )}
                        </div>

                        {/* Icon */}
                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Favicon Icon:</label>
                            {editMeta ? (
                                <>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={(e) => setIconFile(e.target.files[0])}
                                        className="hbtecom-help-input"
                                    />
                                    {meta.icon && (
                                        <img
                                            src={`${process.env.REACT_APP_API_URL}/Images/Meta/${meta.icon}`}
                                            alt="favicon"
                                            style={{ maxWidth: "50px", marginTop: "10px" }}
                                        />
                                    )}
                                </>
                            ) : meta.icon ? (
                                <img
                                    src={`${process.env.REACT_APP_API_URL}/Images/Meta/${meta.icon}`}
                                    alt="favicon"
                                    style={{ maxWidth: "50px" }}
                                />
                            ) : (
                                <span className="hbtecom-help-text">N/A</span>
                            )}
                        </div>

                        {/* Scripts */}
                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Scripts (Header/Footer):</label>
                            {editMeta ? (
                                <textarea
                                    name="scripts"
                                    value={meta.scripts || ""}
                                    onChange={(e) => setMeta((prev) => ({ ...prev, scripts: e.target.value }))}
                                    className="hbtecom-help-input"
                                    placeholder="Paste custom script tags here"
                                    rows={4}
                                />
                            ) : (
                                <pre className="hbtecom-help-text" style={{ whiteSpace: 'pre-wrap' }}>
                                    {meta.scripts || "N/A"}
                                </pre>
                            )}
                        </div>

                        {/* Save / Cancel Buttons */}
                        {editMeta && (
                            <div className="hbtecom-buttons">
                                <button className="hbtecom-btn hbtecom-save" onClick={handleMetaSubmit}>
                                    Save Meta Info
                                </button>
                                <button
                                    className="hbtecom-btn hbtecom-cancel"
                                    onClick={() => {
                                        setEditMeta(false);
                                        setMeta(userMeta); // Restore original
                                        setIconFile(null);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>

                    <div className="hbtecom-help-box">
                        <div className="hbtecom-help-header">
                            <h3 className="hbtecom-help-title">Guest Total(Only for restaurant)</h3>
                            {!editGuest && (
                                <button className="hbtecom-btn hbtecom-help-edit" onClick={() => setEditGuest(true)}>
                                    Edit
                                </button>
                            )}
                        </div>

                        <div className="hbtecom-help-field">
                            <label className="hbtecom-help-label">Minimum Guest:</label>
                            {editGuest ? (
                                <input
                                    type="number"
                                    name="totalminimum"
                                    value={guestData?.totalminimum || ""}
                                    onChange={handleGuestChange}
                                    className="hbtecom-help-input"
                                    placeholder="Enter Minimum Guest"
                                />
                            ) : (
                                <span className="hbtecom-help-text">
                                    {guestData?.totalminimum ? `${guestData.totalminimum}` : "N/A"}
                                </span>
                            )}
                        </div>

                        {editGuest && (
                            <div className="hbtecom-buttons">
                                <button className="hbtecom-btn hbtecom-save" onClick={handleGuestSubmit}>
                                    Save Guest Info
                                </button>
                                <button
                                    className="hbtecom-btn hbtecom-cancel"
                                    onClick={() => {
                                        fetchGUESTData(); // reset to existing
                                        setEditGuest(false);
                                    }}
                                >
                                    Cancel
                                </button>
                            </div>
                        )}
                    </div>
                </div>

            </div>
        </div>


    </>
);
};

export default Setting;